// utils.js or similar file

export function generateNumberArray(begin, month, year) {
    let array = [];
    let end = 30;
    if (month === 2) {
      if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
        end = 29;
      } else end = 28;
    } else {
      if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
        end = 31;
      } else {
        end = 30;
      }
    }
    for (let i = begin; i <= end; i++) {
      array.push((i < 10 ? "0" : "") + i);
    }
    return array;
  }
  
  export function generateArrayOfYears() {
    let min = 1900;
    let max = new Date().getFullYear();
    // let max = new Date().getFullYear() - 18;
    let years = [];
    for (let i = max; i >= min; i--) {
      years.push(i.toString());
    }
    return years;
  }
  
  export function generateMonths() {
    return [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  }
  
  export function generateHours(today, getDate, h) {
    var hr = [];
    var start = 1;
    // if (today === getDate){
    //   start =  h%12? h%12: 12
    // }
  
    for (let i = start; i <= 12; i++) {
      hr.push((i < 10 ? "0" : "") + i);
    }
    return hr;
  }
  export function generateMinutes(today, getDate, min) {
    var mn = [];
    var start = 0;
    // console.log(today,getDate,today===getDate)
    // if (today === getDate){
    //   start =  min < 10 ? '0'+min : min
    // }
    for (let i = start; i < 60; i++) {
      mn.push((i < 10 ? "0" : "") + i);
    }
    return mn;
  }
  export function generateAMPM(hr) {
    if (hr >= 12) return ["PM"];
    return ["AM", "PM"];
  }